import { IDashboardFilter, ISignIn } from "../interfaces";

const defaultDashboardFilters = {
  periodInitialDate: null,
  periodFinalDate: null,
  selectedStatus: [],
};

class UserModel {
  constructor(
    public readonly uid: string,
    public name: string,
    public email: string,
    public readonly creationTime: string,
    public lastSignInTime: string,
    public token: string = "",
    public emailVerified: boolean = false,
    public isAnonymous: boolean = false,
    public readonly providerId: string = "",
    /* A propriedade rubk assinala quem sao os usuarios da Senior Mega, assim qualquer 
      banco de composição upado por um desses usuarios sera automaticamente setado como banco publico. */
    public readonly rubk: boolean = false,
    public photoURL: string = "",
    public phoneNumber: string = "",
    public products?: { faturamento: boolean; orcamento: boolean },
    public lastSignOnFaturamento?: ISignIn,
    public disabled: boolean = false,
    /** Propriedade que controlava se o usuário é Administrador ou não. Depreciada.
     * Agora os usuários terão perfis de acesso definidos pela propriedade roleId. */
    public access: number = 1,
    public roleId: string = "",
    public contractStatusFiltered: string[] = [],
    public dashboardFilters: IDashboardFilter = defaultDashboardFilters
  ) {
    /* Para salvar as datas sem formatacao */
    this.creationTime = this.creationTime
      ? new Date(this.creationTime).getTime().toString()
      : "";
    this.lastSignInTime = this.lastSignInTime
      ? new Date(this.lastSignInTime).getTime().toString()
      : "";
  }

  public setPermissionToFaturamento(): void {
    this.products = { faturamento: true, orcamento: false };
  }

  public setRoleId(roleId: string) {
    this.roleId = roleId;
  }

  public setContractStatusFiltered(status: string[]) {
    this.contractStatusFiltered = status;
  }

  public setDashboardFilters(filters: IDashboardFilter) {
    this.dashboardFilters = filters;
  }

  toSave() {
    return {
      uid: this.uid,
      displayName: this.name,
      email: this.email,
      creationTime: this.creationTime,
      lastSignInTime: this.lastSignInTime,
      rubk: this.rubk,
      token: this.token,
      emailVerified: this.emailVerified,
      isAnonymous: this.isAnonymous,
      providerId: this.providerId,
      disabled: this.disabled,
      roleId: this.roleId,
      contractStatusFiltered: this.contractStatusFiltered,
      dashboardFilters: this.dashboardFilters,
    };
  }
}

export default UserModel;
